import BasicCertificationsProducersRoutes from "./basic_certifications_producers";

export default [...BasicCertificationsProducersRoutes];